import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { PRINCIPAL_FRAGMENT } from '@app/model/authentication/service/AuthorizationGraphQlFragments';

//SecurityGraphQLQueries
export const SIGN_IN_QUERY: GraphQL = {
    name: "signIn",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        query signIn($username: String!, $password: String!){
            signIn(username: $username, password: $password){
                principal {
                    ...PrincipalFields
                }
                token
            }
        }
    `
}

export const SOCIAL_SIGN_IN_MUTATION: GraphQL = {
    name: "socialSignIn",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation socialSignIn($userId:String!, $username: String!, $name: String!, $authProvider: AuthProvider!){
            socialSignIn(userId: $userId, username: $username, name: $name, authProvider: $authProvider){
                principal {
                    ...PrincipalFields
                }
                token
            }
        }
    `
}

export const REFRESH_TOKEN_MUTATION: GraphQL = {
    name: "refreshToken",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation {
            refreshToken{
                principal {
                    ...PrincipalFields
                }
                token
            }
        }
    `
}

export const SIGN_OUT_MUTATION: GraphQL = {
    name: "signOut",
    gql: gql`
        mutation {
            signOut{
                exception
                success
            }
        }
    `
}